import script from "./labels.vue?vue&type=script&lang=js"
export * from "./labels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/i18n/it/labels.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "363769cb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('363769cb', __exports__)) {
    api.reload('363769cb', __exports__)
  }
  
}


export default __exports__